import { Injectable } from '@angular/core';
import { Observable, finalize, of, shareReplay, tap } from 'rxjs';
import { ApiService } from 'quangular';
import { QUILT_SUGGESTED_QUESTION_COUNT } from '@app/config/chat';

@Injectable({
  providedIn: 'root',
})
export class QuiltSuggestedQuestionsService {
  private quiltSuggestedQuestionsCache: string[] | null = null;
  private quiltSuggestedQuestionsRequest$: Observable<string[]> | null = null;

  constructor(private readonly apiService: ApiService) {}

  private getStaticQuestions(type: string, limit = 3): Observable<string[]> {
    return this.apiService.get<string[]>(`static-questions?type=${type}&limit=${limit}`);
  }

  /**
   * Fetch up to `limit` static questions for Quilt.
   * Caches results for the current session to avoid repeat calls when switching tabs.
   */
  getQuiltSuggestedQuestions(limit = QUILT_SUGGESTED_QUESTION_COUNT): Observable<string[]> {
    if (this.quiltSuggestedQuestionsCache) {
      return of(this.quiltSuggestedQuestionsCache);
    }

    if (this.quiltSuggestedQuestionsRequest$) {
      return this.quiltSuggestedQuestionsRequest$;
    }

    this.quiltSuggestedQuestionsRequest$ = this.getStaticQuestions('QUILT', limit).pipe(
      tap((questions) => {
        this.quiltSuggestedQuestionsCache = questions || [];
      }),
      finalize(() => {
        this.quiltSuggestedQuestionsRequest$ = null;
      }),
      shareReplay(1),
    );

    return this.quiltSuggestedQuestionsRequest$;
  }
}
